import React from 'react';
import { Link } from 'react-router';
import { ListItem } from 'material-ui/List';

import DownloadIcon from 'material-ui/svg-icons/file/file-download';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import InfoIcon from 'material-ui/svg-icons/action/info';
import ReportIcon from 'material-ui/svg-icons/action/assessment';
import ShareIcon from 'material-ui/svg-icons/social/share';

import ContextIconMenu from '../Common/ContextIconMenu';
import { ReportDialogs } from '../../constants/Dialogs';
import { statusColours } from '../../constants/ColourConstants';

import DialogActions from '../../actions/DialogActionCreator';
import ReportActions from '../../actions/ReportActionCreator';

import ROLES from '../../constants/Roles';

const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};

const getActions = (row) => [
    {
        link: `/dashboard/report/${row.id}`,
        label: 'Preview',
        icon: <InfoIcon />
    },
    {
        link: `/cent/report/${row.id}/results.zip`,
        label: 'Export to CSV',
        target: '_blank',
        icon: <DownloadIcon />
    },
    {
        type:'divider'
    },
    {
        link: `/dashboard/report/${row.id}/edit`,
        label: 'Edit',
        icon: <EditIcon />,
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: row.id,
        title: 'Delete report',
        deleteAction: ReportActions.delete,
        message: (
            <span>Are you sure to delete the report  "{row.name}" ?</span>
        ),
        condition: {
            show:  row.sysStatus > 4,
            roles: [ROLES.ADMIN]
        }
    }
];


const ReportListItem = ({data, actions}) => {

    const linkAction = !data.fileOnly ? { to: `/dashboard/report/${data.id}` } : { onClick: () => DialogActions.open(ReportDialogs.DOWNLOAD, {reportId: data.id, title: data.name}) };
    const actionList = (actions || getActions(data));

    return (
        <ListItem
            style={style.listItem}
            leftAvatar={
                <Link {...linkAction}>
                    <ReportIcon
                        color={statusColours.primary}
                        style={style.icon}
                    />
                </Link>
            }
            primaryText={
                <Link {...linkAction} className="primaryText">
                    {data.name}
                </Link>
            }
            secondaryText={
                <Link {...linkAction} className="secondaryText">
                    <em>{data.filter} - {data.reportType}</em> <br />
                    {!!data.shareable && <ShareIcon className="icon-small" color={!!data.shareKey ? statusColours.primary : statusColours.default}/>}
                </Link>
            }
            secondaryTextLines={2}
            rightIcon={(!!actionList && actionList.length > 0) ? (<ContextIconMenu actions={actionList} data={data}/>) : undefined}
        />
    );
};

export default ReportListItem;
